import React, { createContext, useContext, useState, useEffect } from 'react';
import ControlButton from '../../ui/ControlButton';
import { usePlayerContext } from '../../Context';
import { BigButton, Events, State } from '../../../types/player';
import { upperFirst } from 'lodash';

const Mute = () => {
  const { sdk } = usePlayerContext();

  const toggleMute = () => {
    sdk.toggleMute();
  };

  const prefix = sdk.getClassNamePrefix();
  const bigButton = sdk.options().getControls().getBigButton() as BigButton;
  const [show, setShow] = useState<boolean>(
    bigButton.showMute === false ? false : true,
  );
  const [isHide, setHide] = useState<boolean>(false);
  const [isShrinked, setIsShrinked] = useState<boolean>(
    sdk.options().getControls().isMuteButtonShrinked(),
  );
  let listeners: any = [];

  useEffect(() => {
    listeners.push(
      sdk.on(Events.MOUSE_OVER, (isHover: boolean) => {
        if (bigButton.stickyMute) return;
        else if (!isHover) setHide(true);
        else setHide(false);
      }),
    );

    let shrinkMuteAfterTimeout = bigButton.shrinkMuteAfterTimeout || -1;

    if (shrinkMuteAfterTimeout > 0) {
      setTimeout(() => {
        //setText('');
        setIsShrinked(true);
        sdk.options().getControls().setMuteButtonShrinked(true);
      }, shrinkMuteAfterTimeout);
    }

    return () => {
      listeners.forEach((off: any) => off());
    };
  }, []);

  if (!show) return null;

  let shrinkedClass = isShrinked
    ? `${prefix}-player-control-big-button-mute-shrinked`
    : '';
  let hidedClass = isHide
    ? `${prefix}-player-control-big-button-mute-hided`
    : '';

  if(sdk.options().hasAudio() === false)
    return null;

  return (
    <div
      className={`${prefix}-player-control-big-button ${prefix}-player-control-big-button-${bigButton?.position} ${prefix}-player-control-big-button-mute ${shrinkedClass} ${hidedClass}`}
      onPointerUp={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleMute();
      }}
      role="button"
      //tabIndex={0}
      onKeyDown={() => {}}
    >
      <ControlButton
        className={'volume-mute'}
        icon={'volumeHigh'}
        handleAction={() => {}}
        title={'Click to unmute'}
      />
    </div>
  );
};

export default Mute;
